// extracted by mini-css-extract-plugin
export default {"modal":"TheLittleModal_modal__oLXx","content":"TheLittleModal_content_gZGp2","btnGroup":"TheLittleModal_btnGroup_eZoZA"};